import React, { PureComponent, Component } from 'react';
import CheckDefecto from '../../../../Common/Components/CheckDefecto'

class Mensual extends Component {
    constructor(props) {
        super(props)
        this.state = {
            DiaMes: props.data.calendario.DiaMes
        };
        this.selectRadio = this.selectRadio.bind(this);
    }


    selectRadio(value) {
        this.props.selectRadio("Periodicidad", value)
    }

    onChange(event) {
        const { value, dataset } = event.target;
        const regExp = new RegExp(dataset.validation);

        if ((regExp.test(value) || value.replace(/\s/g, "", "") == "")) {
            let newState = {
                [dataset.code]: value
            }
            this.setState(newState);
            this.props.changeInput(dataset.code, value);
        }
    }

    onBlur(event) {
        const { value, dataset } = event.target;
        
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            DiaMes: nextProps.data.proceso.Periodicidad == "Mensual" ? nextProps.data.calendario.DiaMes : ""
        });
    }

    render() {

        const { proceso, calendario, ERROR_PROCESS } = this.props.data;

        return (
            <div className="row top-separator-xs" style={{marginLeft:"20px"}}>
                <div className="row">
                    <div className="col-xs-3">
                        <div className="row row-radio">
                            <div className="col-xs-10">
                                <div className="container-radio radio-margin" style={{marginLeft:"-5px"}}>
                                    <input id={"rbDiaEspecifico" + 1}
                                        type="radio"
                                        name="rbDiaEspecifico"
                                        data-value={"Mensual"}
                                        value={true}
                                        checked={proceso.Periodicidad == "Mensual"}
                                        onChange={(event) => this.selectRadio(event.target.dataset.value)}
                                    />

                                    <label
                                        className="lbl-radio label-secondary"
                                        htmlFor={"rbDiaEspecifico" + 1}>
                                        {"Día específico del mes"}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-2" style={{right:"95px"}}>
                        <input className="form-control form-control-tarjetas input-Short"
                            maxLength={2}
                            value={this.state.DiaMes}
                            data-code="DiaMes"
                            data-validation="^([0-9]?\d|100)$"
                            disabled={proceso.Periodicidad != "Mensual"}
                            onChange={this.onChange.bind(this)}
                            //onBlur={this.onBlur.bind(this)}
                        />
                    </div>
                </div>

                <CheckDefecto
                    nombre={"Contar Sólo Días Hábiles Desde el Comienzo del Mes"}
                    referencia={"DiasHabiles" + 3}
                    id={"DiasHabiles" + 3}
                    activo={proceso.Periodicidad == "Mensual"}
                    check={calendario.DiaHabil && proceso.Periodicidad == "Mensual"}
                    selectCheckBox={(event) => this.props.setCheck("DiaHabil", event.target.checked)}
                    style={{ marginLeft : "17px"}}
                />


                {!ERROR_PROCESS["seleccionoDiaMensual"] && proceso.Periodicidad == "Mensual" &&
                    <label className="error">{"Debe completar entre 1 y 31."}</label>}

            </div>
        )
    }
};

export default Mensual;